// src/services/api.ts
import axios from 'axios';

// Upewnij si�, �e ten adres i port HTTP s� poprawne
// U�ywamy zmiennej �rodowiskowej, aby dynamicznie ustawi� adres API
const API_URL = process.env.REACT_APP_API_URL;

const api = axios.create({
  baseURL: API_URL,
});

// WA�NY KROK: Dodajemy "interceptora" zapyta�.
// Ta funkcja b�dzie uruchamiana PRZED ka�dym wys�anym zapytaniem.
api.interceptors.request.use(
    (config) => {
        // Pobieramy token z localStorage przy ka�dym zapytaniu
        const token = localStorage.getItem('token');
        if (token) {
            // Je�li token istnieje, dodajemy go do nag��wka Authorization
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        // Obs�uga b��du
        return Promise.reject(error);
    }
);

export default api;